import DefaultColumnFilter from '../components/DefaultColumnFilter'; // 确保正确导入
import SelectColumnFilter from '../components/SelectColumnFilter'; // 如果需要下拉过滤器

export const allColumns = (handleEdit) => [
    { Header: 'id', accessor: 'id', Filter: null, canFilter: false },
    { Header: 'chat_data_id', accessor: 'chat_data_id', Filter: null, canFilter: false },
    { Header: 'Query', accessor: 'Query', Filter: DefaultColumnFilter, canFilter: true },
    { Header: 'Answer', accessor: 'Answer', Filter: DefaultColumnFilter, canFilter: true },
    { Header: 'Author', accessor: 'Author', Filter: DefaultColumnFilter, canFilter: true },
    { Header: 'Reviewer', accessor: 'review_username', Filter: DefaultColumnFilter, canFilter: true },
    { Header: 'Reviewer ID', accessor: 'review_user_id', Filter: DefaultColumnFilter, canFilter: true },
    {
        Header: '审核状态',
        accessor: 'review_conclusion',
        Filter: SelectColumnFilter,
        canFilter: true,
    },
    {
        Header: 'Create Time',
        accessor: 'Create_time',
        Cell: ({ value }) => (value ? new Date(value).toLocaleString() : 'N/A'),
        Filter: null,
        canFilter: false,
    },
    {
        Header: 'Review Time',
        accessor: 'review_time',
        Cell: ({ value }) => (value ? new Date(value).toLocaleString() : 'N/A'),
        Filter: null,
        canFilter: false,
    },
    {
        Header: '审核操作',
        Cell: ({ row }) => (
            <button
                onClick={() => handleEdit(row.original)}
                disabled={row.original.review_conclusion === '已审核' || row.original.review_conclusion === '放弃'}
                className="review-button"
            >
                审核
            </button>
        ),
        Filter: null,
        canFilter: false,
    },
];